/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type HTMLAttributes, createContext, forwardRef } from 'react';
import { type ContextValue, DEFAULT_SLOT, Provider, useContextProps } from 'react-aria-components';
import { CloseStrokeIcon } from '../../icons/close-stroke/close-stroke.icon';
import { ReplyStrokeIcon } from '../../icons/reply-stroke/reply-stroke.icon';
import { $ } from '../../tokens.stylex';
import { ChatTextFieldContext } from '../chat-text-field/chat-text-field.component';
import { IconButtonContext } from '../icon-button/icon-button.component';
import { IconContext } from '../icon/icon.component';
import { ViewContext } from '../view/view.component';

interface ChatMessageBarProps extends Omit<HTMLAttributes<HTMLDivElement>, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const ChatMessageBarContext = createContext<ContextValue<ChatMessageBarProps, HTMLDivElement>>({});

const ChatMessageBar = forwardRef((props: ChatMessageBarProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, ChatMessageBarContext);

  const { style, children, ...attributes } = props;

  return (
    <div ref={ref} {...stylex.props(styles.base, style)} {...attributes}>
      <Provider
        values={[
          [ViewContext, {
            slots: {
              [DEFAULT_SLOT]: {
                style: inputFieldStyles.base,
              },
              [CHAT_MESSAGE_BAR_SLOTS.CONTEXT]: {
                style: contextStyles.base,
              },
            },
          }],
          [IconButtonContext, {
            slots: {
              [DEFAULT_SLOT]: {
                variant: 'ghost',
                size: 32,
                isRounded: true,
              },
              [CHAT_MESSAGE_BAR_SLOTS.CLEAR_CONTEXT_ICON_BUTTON]: {
                variant: 'ghost',
                size: 32,
                isRounded: true,
                'aria-label': 'Clear reply context',
                children: <CloseStrokeIcon />,
              },
            },
          }],
          [IconContext, {
            slots: {
              [DEFAULT_SLOT]: {
                size: 20,
                children: <ReplyStrokeIcon />
              },
            }
          }],
          [ChatTextFieldContext, {
            size: 40,
            isRounded: true,
          }]
        ]}>
        {children}
      </Provider>
    </div>
  );
});

const styles = stylex.create({
  base: {
    gap: 9,
    paddingInline: 10,
    alignItems: 'stretch',
    alignSelf: 'stretch',
    backdropFilter: 'blur(44px)',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 16,
  },
});

const contextStyles = stylex.create({
  base: {
    gap: 10,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
});

const inputFieldStyles = stylex.create({
  base: {
    borderColor: $.buttonSurfacePrimary,
    borderRadius: 999,
    borderStyle: 'solid',
    borderWidth: 2,
    gap: 2,
    alignItems: 'center',
    alignSelf: 'stretch',
    backgroundColor: $.surface00,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 4,
    paddingLeft: 17,
    paddingRight: 4,
    paddingTop: 4,
  },
});

const CHAT_MESSAGE_BAR_SLOTS = {
  CONTEXT: 'context',
  CLEAR_CONTEXT_ICON_BUTTON: 'clear-context-icon-button',
} as const;

export { CHAT_MESSAGE_BAR_SLOTS, ChatMessageBar, ChatMessageBarContext, type ChatMessageBarProps };
